<button class="button" fxHide fxShow.gt-sm mat-button (click)="toggleFullscreen()" fxFlex="grow"
matTooltip="FULLSCREEN" matTooltipClass="table_tooltip_job_filename" matTooltipPosition="below">
  <mat-icon *ngIf="!isFullscreen">fullscreen</mat-icon>
  <mat-icon *ngIf="isFullscreen">fullscreen_exit</mat-icon>
</button>
